import EducationCertificatesField from './EducationCertificatesField.component';

export default EducationCertificatesField;
